module.exports = __webpack_public_path__ + "static/other/zoo.f8fd4f39.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/zoo.json
// module id = 2521
// module chunks = 0